import React, { FC } from 'react'

import { VipCrown3Svg } from 'components/presentational/svg/VipCrown3Svg'
import { VipNewYearCrownSvg } from 'components/presentational/svg/VipNewYearCrownSvg'
import { useIsNewYear } from 'hooks/useIsNewYear'

export const VipCrownSwitch: FC<{
  width?: number | string
  height?: number | string
}> = ({ width = 144, height = 124 }) => {
  const { isNewYear } = useIsNewYear()

  if (isNewYear) {
    return <VipNewYearCrownSvg width={width} height={height} />
  }

  return <VipCrown3Svg width={width} height={height} />
}
